export default {
    editsList: []
}
